import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    CanActivate,
    CanActivateChild,
    Router,
    RouterStateSnapshot,
} from "@angular/router";
import { HealthAndSafetyAdminService } from "../health-and-safety/admin-service";

@Injectable()
export class HealthAndSafetyAuth implements CanActivate, CanActivateChild {
    private readonly router: Router;
    private readonly healthAndSafetyAdminService: HealthAndSafetyAdminService;

    constructor(
        router: Router,
        healthAndSafetyAdminService: HealthAndSafetyAdminService
    ) {
        this.router = router;
        this.healthAndSafetyAdminService = healthAndSafetyAdminService;
    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean> {
        return this.isAllowedAccess(route, state);
    }

    canActivateChild(
        childRoute: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean> {
        return this.isAllowedAccess(childRoute, state);
    }

    private async isAllowedAccess(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean> {
        let returnVal = false;
        let accessTypes = route.data.accessTypes;

        try {
            returnVal = await this.healthAndSafetyAdminService.canAccess(
                accessTypes
            );

            if (!returnVal) this.router.navigateByUrl("/unauthorized");
        } catch {
            this.router.navigateByUrl("/unauthorized");
        }

        return returnVal;
    }
}
